
  import { defineComponent } from 'vue';
  import { mapMutations } from 'vuex';

  import FileLocalMultiUploadRedesigned from '@/common/components/redesigned/fileUploads/FileLocalMultiUploadRedesigned.vue';
  import constants from '@/common/constants';
  import security from '@/common/mixins/security';
  import { buildFormDataByArray } from '@/common/utils/file';

  import calculationApi from '@/modules/ved/api/Calculation';

  import CalculationForm from '../components/common/CalculationForm.vue';
  import CalculationPageWrapper from '../components/common/CalculationPageWrapper.vue';
  import { CALCULATION_COMMON_GETTERS_NAME, CALCULATION_COMMON_MUTATIONS_NAME } from '../store/calculationCommon/name';
  import { TCalculationActiveInfo, UploadingDataStatusTypes } from '../types/calculation-common';
  import { getFileFieldSubtitle } from '../utils/calculation';

  export default defineComponent({
    name: 'NSIDataUploading',
    components: {
      CalculationForm,
      FileLocalMultiUploadRedesigned,
      CalculationPageWrapper,
    },
    mixins: [security],
    data(): {
      files: File[];
      isUploadingFile: boolean;
    } {
      return {
        files: [],
        isUploadingFile: false,
      };
    },
    computed: {
      FILE_PATH() {
        return 'zip';
      },
      getFileSubtitle(): string {
        return getFileFieldSubtitle(this.FILE_PATH);
      },
      getUploadingDataStatus() {
        return this.$store.getters[CALCULATION_COMMON_GETTERS_NAME.getUploadingDataStatus] as TCalculationActiveInfo;
      },
      getIsFormLoading(): boolean {
        return (
          (this.getUploadingDataStatus.type === this.getType && this.getUploadingDataStatus.isProgress) ||
          this.isUploadingFile
        );
      },
      getIsLoading(): boolean {
        return this.getIsFormLoading || !!this.getUploadingDataStatus.processingId;
      },
      getType(): UploadingDataStatusTypes {
        return UploadingDataStatusTypes.NSI_UPLOADING;
      },
    },
    methods: {
      ...mapMutations({
        setUploadingDataStatus: CALCULATION_COMMON_MUTATIONS_NAME.setUploadingDataStatus,
      }),
      async handleSubmitForm() {
        try {
          this.isUploadingFile = true;
          const processingId = (await calculationApi.startNsiRecalculation(buildFormDataByArray(this.files))).data;

          const newUploadingDataStatus: TCalculationActiveInfo = {
            isProgress: true,
            type: this.getType,
            processingId,
          };

          this.setUploadingDataStatus(newUploadingDataStatus);
        } catch (error) {
          console.error(error);
        } finally {
          this.isUploadingFile = false;
        }
      },
    },
    mounted() {
      this.checkPermissionAndRedirect(constants.Permissions.ForeignTradeAnalyticsNsiLoaderUpload);
    },
  });
